import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import '../css/Mural.css';
import { db, ANO } from '../firebase/logar';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, settings, sadOutline, arrowForward, people, calendar, eye, peopleCircleOutline, newspaper, arrowBack, calendarNumberOutline, calendarNumber, chevronBack, chevronForward, chevronForwardCircle, pencil } from 'ionicons/icons';
import { lerProvas, enviarProvas, excluirProva } from '../firebase/provas';
import { consultarBoletim } from '../apis/sed';
import { enviarEventoCalendario, excluirEventoCalendario, lerCalendario, lerMesCalendario } from '../firebase/calendario';
import swal from 'sweetalert';

const Mural = () => {
  
  // DADOS
  const aluno = localStorage.getItem('aluno');
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const storedSerie = localStorage.getItem('serie');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);
  const [serie, setSerie] = useState(storedSerie ? storedSerie : null);
  const [provas, setProvas] = useState([]);
  const [carregando, setCarregando] = useState(true);

  // ADICIONAR SERIES
  const listaSeries = localStorage.getItem('series');
  const series = listaSeries ? JSON.parse(listaSeries) : [];

  // PAGINAS
  if (!logado) {
    localStorage.clear();
    window.location.href = "../logar";
  }

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());
  
  const listarProvas = useCallback( async () => {
    try {
      setCarregando(true);
      setProvas([]);
      const resposta = await lerProvas(serie);
      setProvas(resposta);
    } catch {
      console.log('erro')
    } finally {
      setCarregando(false);
    }
  }, [serie]);

  useEffect(() => {    
    if (logado === 'responsavel') {
      listarProvas();
    }
  }, [listarProvas]);


  const [mostrarOutrasProvas, setMostrarOutrasProvas] = useState(false);
  const outrasProvas = async (valor) => {
    if (valor === "true") {
      setMostrarOutrasProvas(true);
    } else {
      setMostrarOutrasProvas(false);
    }
  };


  // INPUTS
  const [prova, setProva] = useState('');
  const [serieProva, setSerieProva] = useState('');
  const [dataProva, setDataProva] = useState('');
  const [corFundoProva, setCorFundoProva] = useState('#144774');
  const [corTextoProva, setCorTextoProva] = useState('#ffffff');

  // ABRIR FORMULARIO
  const [abrirFormProvas, setAbrirFormProvas] = useState(false);
  const handleAbrirFormProvas = () => {
    setAbrirFormProvas(true);
  }



  const [serieSelecionada, setSerieSelecionada] = useState('');
  const [lerSeries, setLerSeries] = useState(false);
  const [abrirLerProvas, setAbrirLerProvas] = useState(false);

  const handleLerSeries = async () => {
    setLerSeries(true);
  }

  const handleLerProvas = async (serie) => {
    setAbrirLerProvas(true);
    setLerSeries(false);
    setSerieSelecionada(serie);
    const provas = await lerProvas(serie);
    if (provas.length) {
      setProvas(provas);
    } else {
      setCarregando(false);
    }
  }


  // PAGINAS
  const [calendario, setCalendario] = useState(false);
  const [editarCalendario, setEditarCalendario] = useState(false);
  const [avaliacoes, setAvaliacoes] = useState(false);
  const [boletim, setBoletim] = useState(false);

  // BTNS DE VOLTAR
  const [btnVoltarInicioResponsavel, setBtnVoltarInicioResponsavel] = useState(false);
  const [btnVoltarInicioServidor, setBtnVoltarInicioServidor] = useState(false);
  const [btnVoltarSeriesServidor, setBtnVoltarSeriesServidor] = useState(false);

  const voltarInicioResponsavel = () => {
    document.querySelector('.container-mural').style.background = "var(--light)";
    setBtnVoltarInicioResponsavel(false);
    setAvaliacoes(false);
    setCalendario(false);
    setBoletim(false);
  }

  const voltarInicioServidor = () => {
    document.querySelector('.container-mural').style.background = "var(--light)";
    setBtnVoltarInicioServidor(false);
    setAbrirFormProvas(false);
    setLerSeries(false);
    setAbrirLerProvas(false);
    setCalendario(false);
    setEditarCalendario(false);
  }

  const voltarSeriesServidor = () => {
    setBtnVoltarInicioServidor(true);
    setBtnVoltarSeriesServidor(false);
    setAbrirFormProvas(false);
    setAbrirLerProvas(false);
    setLerSeries(true);
    setProvas([]);
  }


  // BOLETIM
  const ra = localStorage.getItem('usuarioSed') ? localStorage.getItem('usuarioSed') : null;
  const nascimento = localStorage.getItem('nascimentoAluno') ? localStorage.getItem('nascimentoAluno') : null;
  const [anoBoletim, setAnoBoletim] = useState(ANO);
  const [boletimHtml, setBoletimHtml] = useState('');
  const [erroBoletim, setErroBoletim] = useState('');
 
  const handleConsultarBoletim = async (anoBoletim) => {
    const RA = ra.slice(0, -1);
    const DIGITO = ra.slice(-1);
    const NASCIMENTO = nascimento;
    try {
      const resposta = await consultarBoletim(RA, DIGITO, NASCIMENTO, anoBoletim);
      await setBoletimHtml(resposta);
      await setErroBoletim('');
    } catch (error) {
      await setErroBoletim(error);
      await setBoletimHtml('');
      console.log('erro na consulta do Boletim');
    }
  }


  // CALENDARIO
  const dataAtual = new Date();
  const [mesAtual, setMesAtual] = useState(dataAtual.getMonth() + 1);

  const primeiroDiaMes = new Date(ANO, mesAtual - 1, 1);
  const diaSemana = primeiroDiaMes.getDay();
  
  const corrigirCalendario = []
  for (let i = 0; i < diaSemana; i++) {
    corrigirCalendario.push(<div className='dia corrigido'></div>);
  }

  const diasEscrito = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  const mesesEscrito = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  const semana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
  
  const diasFirebase = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [],
    15: [],
    16: [],
    17: [],
    18: [],
    19: [],
    20: [],
    21: [],
    22: [],
    23: [],
    24: [],
    25: [],
    26: [],
    27: [],
    28: [],
    29: [],
    30: [],
    31: [],
  };

  const [nomeEvento, setNomeEvento] = useState('');
  const [diaEvento, setDiaEvento] = useState('');
  const [mesEvento, setMesEvento] = useState('');
  const [dataEvento, setDataEvento] = useState('');
  const [eventos, setEventos] = useState([]);
  const [meses, setMeses] = useState({});
  const [dias, setDias] = useState({});
  
  const handleLerCalendario = async () => {
    try {
      const mesesLidos = await lerCalendario();
      setMeses(mesesLidos);
      setDias(mesesLidos[mesAtual] || {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: [],
        11: [],
        12: [],
        13: [],
        14: [],
        15: [],
        16: [],
        17: [],
        18: [],
        19: [],
        20: [],
        21: [],
        22: [],
        23: [],
        24: [],
        25: [],
        26: [],
        27: [],
        28: [],
        29: [],
        30: [],
      });
      setEventos([]);
      document.querySelector('.container-mural').style.background = "var(--tree)";
    } catch (error) {
      console.error('Erro ao ler o calendario!', error)
    }
  }
  
  const handleLerDias = (mes) => {
    try {
      const diasLidos = meses[mes] || {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: [],
        11: [],
        12: [],
        13: [],
        14: [],
        15: [],
        16: [],
        17: [],
        18: [],
        19: [],
        20: [],
        21: [],
        22: [],
        23: [],
        24: [],
        25: [],
        26: [],
        27: [],
        28: [],
        29: [],
        30: [],
      };
      setDias(diasLidos);
      setEventos([]);
    } catch (error) {
      console.error('Erro ao ler o calendario!', error)
    }
  }


  const handleLerMesCalendario = async (mes) => {
    try {
      const diasLidos = await lerMesCalendario(mes) || false;
      if (!diasLidos) {
        swal({
          title: `O mês de ${mesesEscrito[mes-1]} não tem nenhum evento!`,
          icon: 'warning'
        });
      }
      setMesEvento(mes);
      setDias(diasLidos);
      if (diaEvento) {
        var eventosLidos = diasLidos[diaEvento];
        setEventos(eventosLidos);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleVerDiaCalendario = async (dia) => {
    if (dias === false) {
      swal({
        title: `O mês de ${mesesEscrito[mesEvento-1]} não tem nenhum evento!`,
        icon: 'warning',
      });
      return;
    }
    if (Object.values(dias).length === 0) {
      swal({
        title: 'Escolha um mês primeiro!',
        icon: 'warning'
      });
      return;
    }
    try {
      var eventosLidos = dias[dia];
      setDiaEvento(dia);
      setEventos(eventosLidos);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <main className="container-mural">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <header className="local">

        {btnVoltarInicioResponsavel ? (
          <IonIcon onClick={voltarInicioResponsavel} icon={arrowBack} />
        ) : (
          <></>
        )}

        {btnVoltarInicioServidor ? (
          <IonIcon onClick={voltarInicioServidor} icon={arrowBack} />
        ) : (
          <></>
        )}

        {btnVoltarSeriesServidor ? (
          <IonIcon onClick={voltarSeriesServidor} icon={arrowBack} />
        ) : (
          <></>
        )}

        <h1>Mural</h1>
        <Link to="/app/configuracoes">
          <IonIcon icon={settings} />
        </Link>

      </header>

      
          {logado === 'responsavel' ? (
            <section className="content-mural">

              {!calendario && !avaliacoes && !boletim ? (
                <>
                  <div className="decoracao mt-35 mb-10">
                      <p>Serviços Escolares</p>
                  </div>
                  
                  <div className="lista-chat">
                    <ul>
                      <li onClick={ async () => {
                        await handleLerCalendario();
                        setCalendario(true);
                        setBtnVoltarInicioResponsavel(true);  
                      }}>
                        <IonIcon icon={calendarNumber} />
                        <h1>Calendário Escolar {ANO}</h1>
                        <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        setAvaliacoes(true);
                        setBtnVoltarInicioResponsavel(true);  
                      }}>
                        <IonIcon icon={calendar} />
                        <h1>Avaliações Bimestrais</h1>
                        <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        setBoletim(true);
                        setBtnVoltarInicioResponsavel(true);  
                        handleConsultarBoletim(ANO);
                      }}>
                        <IonIcon icon={newspaper} />
                        <h1>Boletim Escolar</h1>
                        <IonIcon icon={arrowForward} />
                      </li>
                    </ul>
                  </div>
                </>
              ) : (
                <>
                  {avaliacoes && (
                    <>
                      <div className="decoracaoProvas">
                        <h1>Avaliações Bimestrais de {ANO}</h1>
                      </div>
                              
                      <article className="quadro">

                        {provas.length > 0 ? (
                          provas.map((dado, index) => (
                            <div style={{ background: dado.corFundo, color: dado.corTexto}} className="prova">
                              <h1><strong>Prova:</strong> <p>{dado.disciplina}</p></h1>
                              <h1><strong>Turma:</strong> <p>{dado.serie}</p></h1>
                              <h1><strong>Data:</strong> <p>{dado.data}</p></h1>
                            </div>
                          ))
                        ) : (
                          carregando ? (
                            <section className="carregando-mural none">
                              <span></span>
                              <h2>Carregando..</h2>
                            </section>
                          ) : (
                            <div className="erro-mural">
                              <IonIcon icon={sadOutline} />
                              <h1>Nenhuma prova encontrada</h1>
                            </div>
                          )
                        )}
                        
                      </article>
                    </>
                  )}  

                  {boletim && (
                    <div className='boletim'>
                      <div className="decoracao mt-35 mb-0">
                        <p>Boletim do Aluno</p>
                      </div>
                             
                      <div className="form-tecvit form-person">
                        
                        <div className="flex">
                          <select defaultValue={ANO} onChange={(e) => {
                            //setAnoBoletim(e.target.value);
                            handleConsultarBoletim(e.target.value);
                          }} placeholder=" ">
                            <option value={ANO}>{ANO}</option>
                            <option value={ANO - 1}>{ANO - 1}</option>
                            <option value={ANO - 2}>{ANO - 2}</option>
                            <option value={ANO - 3}>{ANO - 3}</option>
                            <option value={ANO - 4}>{ANO - 4}</option>
                            <option value={ANO - 5}>{ANO - 5}</option>
                          </select>
                          <label>Ano Letivo</label>
                        </div>
                      </div>
                        
                      {boletimHtml && (
                        <div className="divBoletim" dangerouslySetInnerHTML={{ __html: boletimHtml }} />
                      )}

                      {erroBoletim && (
                        <div className='erroBoletim'>
                          <h1>Houve algum erro ao consultar o boletim do aluno(a) <strong>{aluno}</strong> !</h1>
                          <p>Verifique se seus dados da SED (Secretaria da Educação Digital) estão corretos.</p>
                          <span><strong>Ra ( Registro do Aluno ):</strong> {ra}</span>
                          <span><strong>Data de Nascimento:</strong> {nascimento}</span>
                          <p>Se os dados informados não estão corretos, clique no botão abaixo para editá-los.</p>
                          <a href='/app/perfil?pagina=editarPerfil#sed'>Editar Dados</a>
                        </div>
                      )}       

                    </div>
                  )}  

                  {calendario && (
                    <div className='calendario-container wd-100'>
                             
                      <div className='mes'>
                        <IonIcon onClick={() => {
                          setMesAtual(mesAtual === 1 ? 12 : mesAtual - 1);
                          handleLerDias(mesAtual === 1 ? 12 : mesAtual - 1);
                        }} icon={chevronBack} />
                        {mesesEscrito[mesAtual- 1]}
                        <IonIcon onClick={() => {
                          setMesAtual(mesAtual === 12 ? 1 : mesAtual + 1)
                          handleLerDias(mesAtual === 12 ? 1 : mesAtual + 1);
                        }} icon={chevronForward} />
                      </div>

                      <div className='calendario'>
  
                        <div className='semanas'>
                          {semana.map((sem, index) => (
                            <div className='semana'>{sem}</div>
                          ))}
                        </div>
                        
                        <div className='dias'>
                          
                          {corrigirCalendario}

                          {Object.keys(dias).map((dia, index) => {
                            const eventosDoDia = dias[dia] ? dias[dia].join(", ") : null;
                            const numeroEventos = dias[dia].length;
                            const arrayEventos = dias[dia];

                            const evento = eventosDoDia.trim().toLowerCase();
                            
                            if (!eventosDoDia.trim()) {
                              return (
                                <div onClick={() => setEventos([])} data-content='' className='dia'>{index + 1}</div>
                              );
                            } else {
                              if (evento.includes('feriado')) {
                                return (
                                  <div className='dia feriado' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={'1 Feriado'}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              } else if (evento.includes('jeesp')) {
                                return (
                                  <div className='dia jogo' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Jogo` : numeroEventos > 1 ? `${numeroEventos} Jogos` : ''}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              } else if (evento.includes('olimpíada')) {
                                return (
                                  <div className='dia olimpiada' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Olimpíada` : numeroEventos > 1 ? `${numeroEventos} Olimpíadas` : ''}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              }
                              return (
                                <div className='dia' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Evento` : numeroEventos > 1 ? `${numeroEventos} Eventos` : ''}>
                                  <strong className='evento'>{index + 1}</strong>
                                </div>
                              );
                            }
                          })}
                        </div>
                        
                      </div>

                      {eventos.length > 0 ? (
                        <div className='eventos'>
                          {eventos.map((evento, i) => {
                            const eventoFormatado = evento.trim().toLowerCase();
                            if (eventoFormatado.includes('feriado')) {
                              return (
                                <li className='feriado'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );  
                            } else if (eventoFormatado.includes('jeesp')) {
                              return (
                                <li className='jogo'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );  
                            } else if (eventoFormatado.includes('olimpíada')) {
                              return (
                                <li className='olimpiada'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );
                            } else {
                              return (
                                <li>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );
                            }
                          })}
                        </div>
                      ) : (
                        <div className='eventos'>
                          <li>
                            Nenhum evento encontrado!
                          </li>
                        </div>
                      )}
                      

                    </div>
                  )}  
                </>  
              )}
                

            </section>

          ) : logado === 'direcao' || logado === 'coordenacao' ? (
            <div className='width-100'>
            {!abrirFormProvas && !calendario && !editarCalendario && !lerSeries && !abrirLerProvas ? (
                <div className='content-mural'>
                  <div className="decoracao mt-35 mb-10">
                      <p>Serviços</p>
                  </div>
                  
                  <div className="lista-mural">
                    <ul>
                      <li onClick={ async () => {
                        await handleLerCalendario();
                        setCalendario(true);
                        setBtnVoltarInicioServidor(true);  
                      }}>
                        <IonIcon icon={calendarNumber} />
                        <h1>Calendário Escolar {ANO}</h1>
                        <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        setEditarCalendario(true);
                        setBtnVoltarInicioServidor(true);  
                      }}>
                        <IonIcon icon={pencil} />
                        <h1>Editar Calendário Escolar {ANO}</h1>
                        <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        handleAbrirFormProvas();
                        setBtnVoltarInicioServidor(true);
                      }}>
                          <IonIcon icon={calendar} />
                          <h1>Enviar data de prova externa</h1>
                          <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        handleLerSeries();
                        setBtnVoltarInicioServidor(true);
                      }}>
                          <IonIcon icon={eye} />
                          <h1>Ler datas de provas externas</h1>
                          <IonIcon icon={arrowForward} />
                      </li>
                    </ul>
                  </div>
                  
                </div>
              ) : (
                <div className='width-100'>
                    
                    {editarCalendario && (
                      <section className="form-tecvit mt-0 wd-93-5 mb-30">
                        
                        <div className='decoracao mt-20 wd-100'>
                          <p>Enviar Evento</p>
                        </div>
          
                        <div className='flex'>
                          <input onChange={(e) => setNomeEvento(e.target.value)} type="text" value={nomeEvento} placeholder=' ' />
                          <label>Nome do Evento</label>
                        </div>
                        
                        <div className='flex'>
                          <input onChange={(e) => setDataEvento(e.target.value)} type="date" placeholder=' ' />
                          <label>Data: </label>
                        </div>
                        
                        <div className='flex'>
                          <button onClick={() => enviarEventoCalendario(nomeEvento, dataEvento)}>Enviar</button>
                        </div>

                        <div className='decoracao mt-20 wd-100'>
                          <p>Excluír Evento</p>
                        </div>
          
                        <div className='flex'>
                          <select onChange={(e) => handleLerMesCalendario(e.target.value)}>
                            <option>Selecione um mês..</option>
                            {mesesEscrito.map((mes, num) => (
                              <option value={num + 1}>{mes}</option>
                            ))}
                          </select>
                          <label>Mês do Evento</label>
                        </div>
                        
                        <div className='flex'>
                          <select onChange={(e) => handleVerDiaCalendario(e.target.value)}>
                            <option>Selecione um dia..</option>
                            {diasEscrito.map((dia, num) => (
                              <option value={num + 1}>{dia}</option>
                            ))}
                          </select>
                          <label>Dia do Evento</label>
                        </div>

                        <div className='evento-lido'>
                          {eventos && eventos.length > 0 ? (
                            eventos.map((evento, index) => {
                              return (
                                <div>
                                  <h5><strong>{`${index + 1}º Evento:`}</strong> {`${evento}`}</h5>
                                  <button onClick={() => excluirEventoCalendario(evento, diaEvento, mesEvento)}>Excluír Evento</button>
                                </div>
                              );
                            })
                          ) : (
                            <li>Nenhum evento encontrado!</li>
                          )}
                        </div>
          
                      </section>
                    )}

                    {lerSeries && (

                      <div className="lista-chat">
                        
                        <div className="decoracao mt-35 mb-10">
                            <p>Provas das séries</p>
                        </div>
                        
                        <ul>
                          <div className='width-100'>
                            {series.length > 0 ? (
                                series.map((serie, index) => (
                                    <li onClick={() => {
                                      handleLerProvas(serie);
                                      setBtnVoltarSeriesServidor(true);
                                      setBtnVoltarInicioServidor(false);
                                    }} key={index}>
                                      <IonIcon icon={peopleCircleOutline} />
                                      <h1>Provas do {serie}</h1>
                                      <IonIcon icon={arrowForward} />
                                    </li>
                                ))
                                ) : (
                                  <div className="column">
                                  <h1>Nenhuma prova encontrada</h1>
                                </div>
                            )}
                          </div>
                        </ul>

                      </div>

                    )}

                    {abrirLerProvas && (

                      <section style={{margin: '-20px 0px 0px 0px', padding: '0px'}}  className="content-mural">

                        <div className="decoracaoProvas">
                                  
                          <h1>Provas do {serieSelecionada}</h1>

                        </div>
                                
                        <article className="quadro">

                          {provas.length > 0 ? (
                            provas.map((dado, index) => (
                              <div key={index} style={{ background: dado.corFundo, color: dado.corTexto}} className="prova">
                                <h1><strong>Disciplina:</strong> <p>{dado.disciplina}</p></h1>
                                <h1><strong>Turma:</strong> <p>{dado.serie}</p></h1>
                                <h1><strong>Data:</strong> <p>{dado.data}</p></h1>
                                <button onClick={() => excluirProva(dado.disciplina, dado.serie, dado.id)}>Excluir Prova</button>
                              </div>
                            ))
                          ) : (
                            carregando ? (
                              <section className="carregando-mural none">
                                <span></span>
                                <h2>Carregando..</h2>
                              </section>
                            ) : (
                              <div className="erro-mural">
                                <IonIcon icon={sadOutline} />
                                <h1>Nenhuma prova encontrada</h1>
                              </div>
                            )
                          )}
                          
                          
                        </article>

                      </section>

                    )}
                    
                    {abrirFormProvas && (
                      <section className="form-tecvit mt-0 wd-93-5">
                        
                        <div className='decoracao mt-20 wd-100'>
                          <p>Enviar data de Prova Externa</p>
                        </div>

                        <div className='flex'>
                          <select onChange={(e) => {
                            outrasProvas(e.target.value);
                            setProva(e.target.value);
                          }}>
                              <option value="">Escolha uma prova</option>
                              <option value="Prova Paulista">Prova Paulista</option>
                              <option value="Provão Paulista - Saresp">Provão Paulista - Saresp</option>
                              <option value="Saresp">Saresp</option>
                              <option value="Saeb">Saeb</option>
                              <option value="true">Outras</option>
                          </select>
                          <label>Prova: </label>
                        </div>
          
                        {mostrarOutrasProvas && (
                          <div className='flex'>
                            <input onChange={(e) => setProva(e.target.value)} placeholder=" " type="text" />
                            <label>Outra Prova</label>
                          </div>
                        )}
                          
                        <div className='flex'>
                          <select onChange={(e) => setSerieProva(e.target.value)}>
                          <option value="">Escolha uma série</option>
                            {series.length > 0 ? (
                              series.map((serie, index) => (
                                <option key={index} value={serie}>
                                  {serie}
                                </option>
                              ))
                            ) : (
                              <option value="">Nenhuma série disponível</option>
                            )}
                          </select>
                          <label>Série: </label>      
                        </div>
                    
                        <div className='flex'>
                          <input onChange={(e) => setDataProva(e.target.value)} type="date" />
                          <label>Data: </label>
                        </div>
                        
                        <div className='flex'>
                          <input onChange={(e) => setCorFundoProva(e.target.value)} type="color" value={corFundoProva} />
                          <label>Cor de Fundo</label>
                        </div>
                        
                        <div className='flex'>
                          <input onChange={(e) => setCorTextoProva(e.target.value)} type="color" value={corTextoProva} />
                          <label>Cor do Texto</label>
                        </div>
                        
                        <div className='flex'>
                          <button onClick={() => enviarProvas(serieProva, prova, dataProva, corFundoProva, corTextoProva)}>Enviar</button>
                        </div>
          
                      </section>
                  )}

                    
                  {calendario && (
                    <div className='calendario-container wd-100'>
                             
                      <div className='mes'>
                        <IonIcon onClick={() => {
                          setMesAtual(mesAtual === 1 ? 12 : mesAtual - 1);
                          handleLerDias(mesAtual === 1 ? 12 : mesAtual - 1);
                        }} icon={chevronBack} />
                        {mesesEscrito[mesAtual- 1]}
                        <IonIcon onClick={() => {
                          setMesAtual(mesAtual === 12 ? 1 : mesAtual + 1)
                          handleLerDias(mesAtual === 12 ? 1 : mesAtual + 1);
                        }} icon={chevronForward} />
                      </div>

                      <div className='calendario'>
  
                        <div className='semanas'>
                          {semana.map((sem, index) => (
                            <div className='semana'>{sem}</div>
                          ))}
                        </div>
                        
                        <div className='dias'>
                          
                          {corrigirCalendario}

                          {Object.keys(dias).map((dia, index) => {
                            const eventosDoDia = dias[dia] ? dias[dia].join(", ") : null;
                            const numeroEventos = dias[dia].length;
                            const arrayEventos = dias[dia];

                            const evento = eventosDoDia.trim().toLowerCase();
                            
                            if (!eventosDoDia.trim()) {
                              return (
                                <div onClick={() => setEventos([])} data-content='' className='dia'>{index + 1}</div>
                              );
                            } else {
                              if (evento.includes('feriado')) {
                                return (
                                  <div className='dia feriado' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={'1 Feriado'}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              } else if (evento.includes('jeesp')) {
                                return (
                                  <div className='dia jogo' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Jogo` : numeroEventos > 1 ? `${numeroEventos} Jogos` : ''}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              } else if (evento.includes('olimpíada')) {
                                return (
                                  <div className='dia olimpiada' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Olimpíada` : numeroEventos > 1 ? `${numeroEventos} Olimpíadas` : ''}>
                                    <strong className='evento'>{index + 1}</strong>
                                  </div>
                                );  
                              }
                              return (
                                <div className='dia' onClick={() => setEventos(arrayEventos)} data-content={eventosDoDia} data-content-length={numeroEventos === 1 ? `${numeroEventos} Evento` : numeroEventos > 1 ? `${numeroEventos} Eventos` : ''}>
                                  <strong className='evento'>{index + 1}</strong>
                                </div>
                              );
                            }
                          })}
                        </div>
                        
                      </div>

                      {eventos.length > 0 ? (
                        <div className='eventos'>
                          {eventos.map((evento, i) => {
                            const eventoFormatado = evento.trim().toLowerCase();
                            if (eventoFormatado.includes('feriado')) {
                              return (
                                <li className='feriado'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );  
                            } else if (eventoFormatado.includes('jeesp')) {
                              return (
                                <li className='jogo'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );  
                            } else if (eventoFormatado.includes('olimpíada')) {
                              return (
                                <li className='olimpiada'>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );
                            } else {
                              return (
                                <li>
                                  <strong>{`${i + 1}º Evento:`}</strong> {`${evento}`}
                                </li>
                              );
                            }
                          })}
                        </div>
                      ) : (
                        <div className='eventos'>
                          <li>
                            Nenhum evento encontrado!
                          </li>
                        </div>
                      )}
                      

                    </div>
                  )}
                    
                </div>
              )}
            </div>
            
            
          ) :  (
            <div className='width-100'>
            {/* PARA PROFESSOR */}

            {!abrirFormProvas && !lerSeries && !abrirLerProvas ? (
                <div className='content-mural'>
                  <div className="decoracao mt-35 mb-10">
                      <p>Serviços</p>
                  </div>
                  
                  <div className="lista-mural">
                    <ul>
                      <li onClick={() => {
                        handleAbrirFormProvas();
                        setBtnVoltarInicioServidor(true);
                      }}>
                          <IonIcon icon={calendar} />
                          <h1>Enviar data de prova</h1>
                          <IonIcon icon={arrowForward} />
                      </li>
                      <li onClick={() => {
                        handleLerSeries();
                        setBtnVoltarInicioServidor(true);
                      }}>
                          <IonIcon icon={eye} />
                          <h1>Ler datas de provas</h1>
                          <IonIcon icon={arrowForward} />
                      </li>
                    </ul>
                  </div>
                  
                </div>
              ) : (
                <div className='width-100'>

                  {lerSeries && (

                    <div className="lista-chat">
                      
                      <div className="decoracao mt-35 mb-10">
                          <p>Provas das séries</p>
                      </div>
                      
                      <ul>
                        <div className='width-100'>
                          {series.length > 0 ? (
                              series.map((serie, index) => (
                                  <li onClick={() => {
                                    handleLerProvas(serie);
                                    setBtnVoltarSeriesServidor(true);
                                    setBtnVoltarInicioServidor(false);
                                  }} key={index}>
                                    <IonIcon icon={peopleCircleOutline} />
                                    <h1>Provas do {serie}</h1>
                                    <IonIcon icon={arrowForward} />
                                  </li>
                              ))
                              ) : (
                                <div className="column">
                                <h1>Nenhuma prova encontrada</h1>
                              </div>
                          )}
                        </div>
                      </ul>

                    </div>

                  )}

                  {abrirLerProvas && (

                    <section style={{margin: '-20px 0px 0px 0px', padding: '0px'}}  className="content-mural">

                      <div className="decoracaoProvas">
                                
                        <h1>Provas do {serieSelecionada}</h1>

                      </div>
                              
                      <article className="quadro">

                        {provas.length > 0 ? (
                          provas.map((dado, index) => (
                            <div key={index} style={{ background: dado.corFundo, color: dado.corTexto}} className="prova">
                              <h1><strong>Disciplina:</strong> <p>{dado.disciplina}</p></h1>
                              <h1><strong>Turma:</strong> <p>{dado.serie}</p></h1>
                              <h1><strong>Data:</strong> <p>{dado.data}</p></h1>
                              <button onClick={() => excluirProva(dado.disciplina, dado.serie, dado.id)}>Excluir Prova</button>
                            </div>
                          ))
                        ) : (
                          carregando ? (
                            <section className="carregando-mural none">
                              <span></span>
                              <h2>Carregando..</h2>
                            </section>
                          ) : (
                            <div className="erro-mural">
                              <IonIcon icon={sadOutline} />
                              <h1>Nenhuma prova encontrada</h1>
                            </div>
                          )
                        )}
                        
                        
                      </article>

                    </section>

                  )}

                  {abrirFormProvas && (

                    <section className="form-tecvit mt-0 wd-93-5">
                    
                      <div className='decoracao mt-20 wd-100'>
                        <p>Enviar data de Prova</p>
                      </div>

                      <div className='flex'>
                        <select onChange={(e) => {
                          outrasProvas(e.target.value);
                          setProva(e.target.value);
                        }}>
                          <option value="">Escolha uma prova</option>
                          <option value="Matemática">Matemática</option>
                          <option value="Português">Português</option>
                          <option value="História">História</option>
                          <option value="Geografia">Geografia</option>
                          <option value="Ciências">Ciências</option>
                          <option value="Inglês">Inglês</option>
                          <option value="Física">Física</option>
                          <option value="Química">Química</option>
                          <option value="Biologia">Biologia</option>
                          <option value="Sociologia">Sociologia</option>
                          <option value="Filosofia">Filosofia</option>
                          <option value="Ed.Física">Ed. Física</option>
                          <option value="Artes">Artes</option>
                          <option value="Tecnologia">Tecnologia e Inovação</option>
                          <option value="Projeto De Vida">Projeto de Vida</option>
                          <option value="true">Outras</option>
                        </select>
                        <label>Matéria: </label>
                      </div>

                      {mostrarOutrasProvas && (
                        <div className='flex'>
                          <input onChange={(e) => setProva(e.target.value)} placeholder=" " type="text" />
                          <label>Outra Prova</label>
                        </div>
                      )}

                      <div className='flex'>
                        <select onChange={(e) => setSerieProva(e.target.value)}>
                          <option value="">Escolha uma série</option>
                          {series.length > 0 ? (
                                series.map((serie, index) => (
                                    <option value={serie}>
                                        {serie}
                                    </option>
                                ))
                                ) : (
                                <option value="">Nenhuma série disponível</option>
                            )}
                        </select>
                        <label>Série: </label>
                      </div>
                      
                      <div className='flex'>
                        <input onChange={(e) => setDataProva(e.target.value)} type="date" />
                        <label>Data: </label>
                      </div>

                      <div className='flex'>
                        <input onChange={(e) => setCorFundoProva(e.target.value)} type="color" value={corFundoProva} />
                        <label>Cor de Fundo</label>
                      </div>
                      
                      <div className='flex'>
                        <input onChange={(e) => setCorTextoProva(e.target.value)} type="color" value={corTextoProva}/>
                        <label>Cor do Texto</label>
                      </div>

                      <div className='flex'>
                        <button onClick={() => enviarProvas(serieProva, prova, dataProva, corFundoProva, corTextoProva)}>Enviar</button>
                      </div>
                        

                    </section>
                  )}

                </div>
    
              )}
            </div>
            
          )}


    </main>
  );
};


export default Mural;